import { ApiClient } from './client';

export interface RewardItem {
  id: string;
  type: string;
  /** Nombre/descr. EN + ES (editables desde backoffice); null → fallback por `type`. */
  title: string | null;
  titleTranslation: string | null;
  description: string | null;
  descriptionTranslation: string | null;
  /** Imagen subida (hero en detalle + miniatura en lista). */
  imageUrl: string | null;
  cost: number;
  /** 'Próximamente': se muestra pero no se puede canjear todavía. */
  comingSoon: boolean;
  /** Ya tienes el efecto sin consumir (protector: máx 1). */
  owned: boolean;
  /** Puedes canjearla ahora (saldo suficiente y no la tienes ya). */
  redeemable: boolean;
}

export interface RewardsResponse {
  /** Saldo gastable = XP ganado − XP gastado (no afecta al ranking). */
  balance: number;
  items: RewardItem[];
}

export async function getRewards(): Promise<RewardsResponse> {
  return ApiClient.get<RewardsResponse>('/rewards');
}

export async function redeemReward(rewardId: string): Promise<{ ok: boolean; balance: number }> {
  return ApiClient.post<{ ok: boolean; balance: number }>(`/rewards/${rewardId}/redeem`, {});
}
